import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ApiService from "./common/api.service";

import VueMaterial from "vue-material";
import Vuelidate from "vuelidate";
import VueCurrencyFilter from "vue-currency-filter";
import vueNumeralFilterInstaller from "vue-numeral-filter";
import VueFilterDateFormat from "vue-filter-date-format";
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import vSelect from "vue-select";
import FlashMessage from '@smartweb/vue-flash-message';
import { dateFilter } from "vue-date-fns";
import vClickOutside from 'v-click-outside'
import Pagination from 'vue-pagination-2';

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: ".scrollable-content",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.filter('plus', function (value) {
  if(!value) return '';
  return value.includes('-') ? value : `+${value}`;
});
Vue.use(vClickOutside);
import ActionCableVue from "actioncable-vue";
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts);

Vue.component('pagination', Pagination);
Vue.component('apexchart', VueApexCharts);
Vue.use(FlashMessage);
Vue.use(ActionCableVue, {
  connectionUrl: `${process.env.VUE_APP_API_BASE_WS}/api/cable`,
  connectImmediately: false
});

const VueUploadComponent = require("vue-upload-component");

Vue.component("file-upload", VueUploadComponent);
Vue.component('v-select', vSelect);
Vue.filter("date", dateFilter);
Vue.use(VueFilterDateFormat);
Vue.use(VueFilterDateParse);
Vue.use(vueNumeralFilterInstaller);
Vue.use(VueCurrencyFilter, {
  symbol: "$",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: false
});
Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.config.productionTip = false;
ApiService.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
